import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserLibrarianGameProps {
    onComplete: () => void;
}

interface PhaserLibrarianGameState {
}

const gameConfig: GameConfig = {
    title: "Librarian Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserLibrarianGame extends React.Component<PhaserLibrarianGameProps, PhaserLibrarianGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserLibrarianGameProps) {
        super(props);
        bindAllOfThis(this, PhaserLibrarianGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserLibrarianGame;



// WEBPACK FOOTER //
// ./src/games/LibrarianGame/Main.tsx